import axios from "axios";
import { del, get, post, patch,  put } from "./teachers_api_helper";
import * as url from "./teachers_url_helper";





// Get features
export const getTeachers = () => get(url.GET_TEACHERS);


// Add feature
//export const addNewFeature = feature => post(url.ADD_NEW_ACTION, feature);
//export const addNewBranch = branch => post(url.ADD_NEW_BRANCH, JSON.stringify(branch));

export const addNewTeacher = teacher => post(url.ADD_NEW_TEACHER, teacher);



// update feature
//export const updateFeature = feature => put(url.UPDATE_ACTION, feature);
export const updateTeacher = teacher => patch(`${url.UPDATE_TEACHER}/${teacher.id}`,  teacher);


// delete series categories
//export const deleteFeature = feature => del(url.DELETE_ACTION, { headers: { feature } });
export const deleteTeacher = teacher => del(`${url.DELETE_TEACHER}/${teacher.id}`);







export {
  //getLoggedInUser,
  
  
};
